// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__cvU-k","title":"FrontImage_title__VZG4K"};